import type { OrganizationPublicSummary } from '../models/OrganizationPublicSummary';
import type { RoomSummary } from '../models/Room';

export interface RoomSpaceContext {
  id: string;
  city: string;
  name: string;
  currencyCode?: string | null;
}

export interface PublicRoomListContext {
  id: string;
  name: string;
  city: string;
  currencyCode?: string | null;
  rooms: RoomSummary[];
}

export function flattenOrganizationRooms(organization: OrganizationPublicSummary): {
  roomListContext: PublicRoomListContext;
  roomSpaceByRoomId: Record<string, RoomSpaceContext>;
} {
  const roomSpaceByRoomId: Record<string, RoomSpaceContext> = {};
  const rooms: RoomSummary[] = [];

  for (const space of organization.spaces ?? []) {
    for (const room of space.rooms ?? []) {
      rooms.push(room);
      roomSpaceByRoomId[room.id] = {
        id: space.id,
        city: space.city,
        name: space.name,
        currencyCode: space.currencyCode,
      };
    }
  }

  const primarySpace = organization.spaces?.[0];

  return {
    roomListContext: {
      id: organization.id,
      name: organization.name,
      city: primarySpace?.city ?? '',
      currencyCode: primarySpace?.currencyCode ?? null,
      rooms,
    },
    roomSpaceByRoomId,
  };
}
